/*=========================================================================================
  File Name: moduleKainsActions.js
  Description: Kains Module Actions
  ----------------------------------------------------------------------------------------
==============================*/
import statusService from '../../../services/status.service'

export default {
	addStatus({ dispatch }, params) {
		return statusService
			.createStatus(params)
			.then((response) => {
				if (response.success || response.status) dispatch('alertSuccess', response.message, { root: true })
				else dispatch('alertError', response.message, { root: true })
			})
			.catch((error) => {
				dispatch('alertError', error.message, { root: true })
			})
	},
	updateStatus({ commit, dispatch }, data) {
		return statusService
			.updateStatus(data)
			.then((response) => {
				// commit('UPDATE_USER', data)
				if (response.success || response.status) dispatch('alertSuccess', response.message, { root: true })
				else dispatch('alertError', response.message, { root: true })
			})
			.catch((error) => {
				dispatch('alertError', error.message, { root: true })
			})
	},
	fetchStatus({ commit, dispatch }, payload) {
		return statusService
			.getStatus(payload)
			.then((response) => {
				if (response.success || response.status) {
					commit('SET_STATUS', response.data.data)
					commit('SET_INFO_DB', { totalPage: response.data.last_page, totalRow: response.data.total })
					return Promise.resolve(response.data.data)
				}

				dispatch('alertError', response.message, { root: true })
			})
			.catch((error) => {
				dispatch('alertError', error.message, { root: true })
			})
	},
	showStatus({ dispatch }, id) {
		return statusService
			.showStatus(id)
			.then((response) => {
				return Promise.resolve(response.data)
			})
			.catch((error) => {
				dispatch('alertError', error.message, { root: true })
			})
	},
	removeStatus({ commit, dispatch }, ids) {
		return statusService
			.deleteStatus({ cids: ids })
			.then((response) => {
				if (response.success || response.status) dispatch('alertSuccess', response.message, { root: true })
				else dispatch('alertError', response.message, { root: true })
			})
			.catch((error) => {
				dispatch('alertError', error.message, { root: true })
			})
	},
	async getListStatus({ dispatch, commit }, type) {
		return await statusService
			.getListStatus(type)
			.then((response) => {
				if ((response.success || response.status) && response.data) {
					// dispatch("alertSuccess", response.message, { root: true });
					return Promise.resolve(response.data)
				} else {
					dispatch('alertError', response.message, { root: true })
				}
			})
			.catch((error) => {
				dispatch('alertError', error, { root: true })
				return Promise.reject(false)
			})
	}
}
